var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send 002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.61804 9.83357L19.5292 3.08453C20.3921 2.71851 21.2815 3.60791 20.9155 4.47082L14.1664 20.382C13.7495 21.365 12.2847 21.1182 12.1689 20.0455L11.6459 15.1971C11.4851 13.7065 10.2935 12.5149 8.80291 12.3541L3.95448 11.8311C2.88176 11.7153 2.63504 10.2505 3.61804 9.83357Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.6d0097fa748832d413b568a3a0a1a152.svg";
export { ForwardRef as ReactComponent };